import cx from "classnames";
import Link from "next/link";
import { useTranslation } from "next-i18next";

import { LINKS } from "@/constants/links";

import { Icon } from "../elements/Icon";
import { Icons } from "../elements/Icon/types";
import styles from "./style.module.css";

const categories = [
  {
    name: "soap",
    link: LINKS.SHOP_SOAP,
    dispenser: "dispenser_pump" as Icons,
  },
  {
    name: "cleaning",
    link: LINKS.SHOP_CLEANING,
    dispenser: "dispenser_spray" as Icons,
  },
  {
    name: "laundry",
    link: LINKS.SHOP_LAUNDRY,
    dispenser: "dispenser_push_pull" as Icons,
  },
];

export const ShopCategoriesMenu = ({ className }: { className?: string }) => {
  const { t } = useTranslation("common", { keyPrefix: "shop.categories" });

  return (
    <ul className={cx(styles.categoryMenu, className)}>
      {categories.map((item) => {
        return (
          <li key={item.name}>
            <Link href={item.link}>
              <div className={styles.dispenser}>
                <Icon type={item.dispenser} />
              </div>
              <span>{t(item.name)}</span>
              <Icon
                type="arrow_right"
                size="sm"
                className={styles.arrowRight}
              />
            </Link>
          </li>
        );
      })}
    </ul>
  );
};
